import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class VariantProductDetails extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  updateContent = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDetails = event.detail.data.html.querySelector(
      `variant-product-details[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newDetails) return;
    this.replaceWith(newDetails);
  };
}

if (!customElements.get('variant-product-details')) {
  customElements.define('variant-product-details', VariantProductDetails);
}
